import { useEffect } from 'react';
import type { BidCollectorRootResponse } from 'src/apis/snam-bid-collector/types';
import { isServerError, useAxios } from 'src/hooks/use-axios';
import { handleErrorWithNotification } from 'src/utils/handle-error';

export function useBidCollectorRoot() {
  const bidCollectorRoot = useAxios(
    (axios, baseConfig) =>
      axios.request<BidCollectorRootResponse>({
        ...baseConfig,
        url: PRISMA_CONFIG.snamBidCollector,
      }),
    { neededOnPageLoad: true, cacheKey: 'snam-bid-collector-root' }
  );

  useEffect(() => {
    bidCollectorRoot.execute();
    // oxlint-disable-next-line exhaustive-deps
  }, []);

  return bidCollectorRoot;
}

export type BidCollectorRootRequest = ReturnType<typeof useBidCollectorRoot>;

export function useOptionalBidCollectorRoot() {
  const bidCollectorRoot = useAxios(
    (axios, baseConfig) =>
      axios.request<BidCollectorRootResponse>({
        ...baseConfig,
        url: PRISMA_CONFIG.snamBidCollector,
        timeout: 5000,
      }),
    {
      neededOnPageLoad: true,
      cacheKey: 'snam-bid-collector-root',
      onError(error) {
        if (!isServerError(error, 401)) {
          handleErrorWithNotification({
            error,
            setReauthenticate: () => {},
          });
        }
        return error;
      },
    }
  );

  useEffect(() => {
    bidCollectorRoot.execute();
    // oxlint-disable-next-line exhaustive-deps
  }, []);

  return bidCollectorRoot;
}

export type OptionalBidCollectorRootRequest = ReturnType<
  typeof useOptionalBidCollectorRoot
>;
